import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Page from "../../../components/Page";
import Article from "../../../components/Article";
import CustomButton from '../../../components/CustomButton';
import { useLocation, useNavigate } from 'react-router-dom';
import { Routes } from '../../../routes/RouteConstants';
import { Box, Typography, useTheme } from '@mui/material';
import { useTenant } from '../../../contexts/TenantContext';
import DiscountedPrice from '../components/DiscountedPrice';
import ProviderLine from '../../provider/components/ProviderLine';

const BookingSuccessPage = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const { displayConfig } = useTenant();
  // Handed over by the confirmation page; gone after a reload, when the page simply says less.
  const booking = useLocation().state?.booking;

  return (
    <Page>
      <Article
        title="Sikeres foglalás"
        titleVariant="h6"
        alignItems="center"
      >
        <Box
          sx={{
            width: 120,
            height: 120,
            borderRadius: "50%",
            background: `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.light} 100%)`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: 3,
            boxShadow: "0 8px 24px rgba(102, 126, 234, 0.3)",
          }}
        >
          <CheckCircleIcon sx={{ fontSize: 64, color: "#fff" }} />
        </Box>

        <ProviderLine providerId={booking?.providerId} sx={{ mb: 2 }} />

        <Typography align="center" mb={4} color={displayConfig?.color}>
          Az időpontodat rögzítettük, a visszaigazolást e-mailben is elküldtük.
        </Typography>

        {booking?.couponCode && (
          <Typography align="center" mb={4} color={displayConfig?.color} data-testid="booking-success-price">
            Fizetendő: <DiscountedPrice price={booking.price} originalPrice={booking.originalPrice} />
            {` (kupon: ${booking.couponCode})`}
          </Typography>
        )}

        <CustomButton
          variant="outlined"
          text="Foglalás megtekintése"
          onClick={() => navigate(Routes.PROFILE)}
          mt={1}
        />
      </Article>
    </Page>
  );
};

export default BookingSuccessPage;
